
import { useEffect, useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { TOAST_EVENT, ToastPayload } from "../services/toastService";

export default function ToastProvider() {
    const [toasts, setToasts] = useState<ToastPayload[]>([]);

    useEffect(() => {
        const handleToast = (event: Event) => {
            const toast = (event as CustomEvent<ToastPayload>).detail;
            if (!toast?.message) return;

            setToasts((current) => [...current, toast]);
            window.setTimeout(() => {
                setToasts((current) => current.filter((item) => item.id !== toast.id));
            }, toast.duration);
        };

        window.addEventListener(TOAST_EVENT, handleToast);
        return () => window.removeEventListener(TOAST_EVENT, handleToast);
    }, []);

    return (
        <div className="fixed bottom-4 right-4 z-[9999] flex w-[calc(100vw-2rem)] max-w-sm flex-col gap-3" aria-live="polite">
            {toasts.map((toast) => {
                const isSuccess = toast.type === "success";
                const Icon = isSuccess ? CheckCircle2 : XCircle;

                return (
                    <div
                        key={toast.id}
                        className={`flex items-start gap-3 rounded-lg border bg-white px-4 py-3 text-sm shadow-lg ${
                            isSuccess ? "border-green-200 text-green-800" : "border-red-200 text-red-800"
                        }`}
                    >
                        <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${isSuccess ? "text-green-600" : "text-red-600"}`} />
                        <span className="min-w-0 flex-1 break-words font-medium">{toast.message}</span>
                    </div>
                );
            })}
        </div>
    );
}
